<template lang="pug">
  .audit-quotation(v-loading="loading")
    title-bar {{ $t('报价') }}
    div(style="margin-left: 20px")
      QuotationList(:data="list")

    template(v-if="itResult.date")
      title-bar IT {{ $t('审核结果') }}
      div(style="margin-left: 20px")
        el-row
          el-col(:span="4") {{ $t('审核结果') }}
          el-col(:span="8") {{ $t(itResult.status ? $t('通过') : $t('拒绝')) }} ( {{ itResult.date | dateFormatter }} )
        el-row
          el-col(:span="4") {{ $t('备注') }}
          el-col(:span="6")
            display-text-container(:text="itResult.comment")
    title-bar {{ $t('市场部审核报价') }}
    div(v-if="isView" style="margin-left: 20px")
      el-row
        el-col(:span="4") {{ $t('审核结果') }}
        el-col(v-if="marketResult.status != null" :span="8") {{ $t(marketResult.status ? $t('通过') : $t('拒绝')) }} ( {{ marketResult.date | dateFormatter }} )
        el-col(v-else) -
      el-row
        el-col(:span="4") {{ $t('备注') }}
        el-col(:span="6")
          display-text-container(:text="marketResult.comment")
    div(v-else style="margin-left: 20px")
      el-row
        el-col(:span="4") {{ $t('审核结果') }}
        el-col(:span="8")
          el-radio(v-model="audit" :label="1") {{ $t('通过 ') }}
          el-radio(v-model="audit" :label="2") {{ $t('拒绝') }}
      el-row
        el-col(:span="4") {{ $t('备注') }}
        el-col(:span="6" style="position: relative")
          el-input(
            v-model="remark"
            type="textarea"
            :rows="8"
            style="width: 380px"
            :placeholder="$t('备注不多于500字')"
            :class="{'has-error': errors.has('remark_field') }"
            v-validate="'max:500'"
            data-vv-as="remark_field"
            name="remark_field"
          )
          p(class="input-error") {{ errors.first('remark_field') }}
    el-row(style="margin-left: 20px")
      el-col(
        :offset="4"
        :span="20"
      )
        footer-button(
          v-if="!isView"
          @confirm="onConfirm"
          @cancel="$router.push('/campaign/process')"
        )
    template(v-if="versions.length !== 0")
      title-bar {{ $t('历史版本') }}
      div(style="padding: 0 20px;margin-bottom: 50px;margin-top:20px")
        template(v-for="item in versions")
          audit-versions-item(:item = "item" :auditType="5")
</template>

<script>
import axios from 'axios'
import dayjs from 'dayjs'
import TitleBar from '@/components/TitleBar'
import FooterButton from '@/components/FooterButton'
import SendEmailDialog from '@/components/SendEmailDialog'
import QuotationList from '@/components/QuotationList'
import { flatten } from 'lodash'
import AuditVersionsItem from '@/components/AuditVersions/AuditVersionsItem'
import DisplayTextContainer from '@/components/DisplayTextContainer'

const getApproveHistory = (id, businessType, auditType) => {
  return axios.get('/management/subfinal/getApproveHistory', {
    params: {
      id: id,
      business_type: businessType,
      audit_type: auditType
    }
  })
}

export default {
  components: {
    FooterButton,
    TitleBar,
    SendEmailDialog,
    QuotationList,
    AuditVersionsItem,
    DisplayTextContainer
  },
  filters: {
    dateFormatter (str) {
      return str.replace(/-/gi, '/')
    }
  },
  data () {
    return {
      loading: true,
      audit: 1,
      remark: '',
      itResult: {
        date: '',
        status: 0,
        comment: ''
      },
      marketResult: {
        date: '',
        status: 0,
        comment: ''
      },
      list: [],
      screenshotPath: '',
      versions: []
    }
  },
  computed: {
    campaign () {
      return this.$store.state.campaign
    },
    campaignId () {
      return this.$store.state.campaign.id
    }
  },
  mounted () {
    const arr = [
      this.fetchQuotation(),
      this.fetchItResult()
    ]
    if (this.isView) arr.push(this.fetchMarketResult())
    Promise.all(arr).then(() => { this.loading = false })
  },
  methods: {
    // 获取报价
    fetchQuotation () {
      return axios.get('/management/subfinal/getSelectedSubFinalScope', {
        params: {
          campaign_id: this.$store.state.campaign.id,
          is_approved: this.isView ? 1 : 0
        }
      })
        .then(res => {
          this.list = res
          this.getApproveHistory()
        })
    },
    // 获取it审核报价结果
    fetchItResult () {
      return axios.get('/management/subfinal/getApproveResult', {
        params: {
          id: this.campaign.id,
          business_type: this.campaign.businessType,
          audit_type: 3
        }
      })
        .then(res => {
          this.itResult = {
            date: res.date,
            status: res.status,
            comment: res.comment
          }
        })
    },
    // 获取市场部审核报价结果
    fetchMarketResult () {
      return axios.get('/management/subfinal/getApproveResult', {
        params: {
          id: this.campaign.id,
          business_type: this.campaign.businessType,
          audit_type: 4
        }
      })
        .then(res => {
          this.marketResult = {
            date: res.date,
            status: res.status,
            comment: res.comment
          }
        })
    },
    async onConfirm () {
      const validateResult = await this.$validator.validate()
      if (!validateResult) return
      this.$message.success(this.$t('提交成功'))
      if (this.audit === 1) {
        // 审核通过的话，伪造查看界面的数据并截图 之后再正式提交
        this.marketResult = {
          date: dayjs().format('YYYY-MM-DD HH:mm'),
          status: this.audit,
          comment: this.remark
        }
        this.$router.push('audit-quotation?status=completed')
        this.loading = true
        try {
          await this.approve()
          await this.updateCampaignInfo()
          this.$emit('updateTab')
          this.loading = false
        } catch (err) {
          this.loading = false
          throw new Error(err)
        }
      } else {
        // 审核不通过直接提交
        this.loading = true
        try {
          await this.approve()
          await this.updateCampaignInfo()
          this.$emit('updateTab')
          this.$router.push('/campaign/process')
          this.loading = false
        } catch (err) {
          this.loading = false
          throw new Error(err)
        }
      }
    },
    approve () {
      return axios.get('/management/subfinal/approvePriceForMarketing', {
        params: {
          campaign_id: this.campaign.id,
          approve_type: 2,
          business_type: this.campaign.businessType,
          approve_result: this.audit,
          remark: this.remark,
          servlet_path: this.$route.path,
          task_name: this.campaign.taskName,
          attachment_path: this.screenshotPath,
          task_id: this.$store.state.campaign.taskId
        }
      })
    },
    getCampaignOverview () {
      return axios.get('/management/campaign/getCampaignOverview', {
        params: { campaign_id: this.campaign.id }
      })
    },
    getSubFinalScope () {
      return axios.get('/management/subfinal/getSubFinalScopeList', {
        params: { campaign_id: this.campaign.id }
      })
    },
    async updateCampaignInfo () {
      this.loading = true
      const [res1, res2] = await Promise.all([this.getCampaignOverview(), this.getSubFinalScope()])
      this.$store.commit('campaign/setPhaseType', res1.phase_type)
      this.$store.commit('campaign/setBusinessType', res1.business_type)
      this.$store.commit('campaign/setOriginalBusinessType', res1.business_type)
      this.$store.commit('campaign/setSubFinalScopeId', res2[0].sub_final_scope_id)
      this.loading = false
    },
    getApproveHistory () {
      Promise.all(this.list.map(i => {
        return getApproveHistory(i.sub_final_scope_vendor_id, 4, 5)
      }))
        .then(res => {
          this.versions = flatten(res)
        })
    }
  }
}
</script>

<style lang="stylus">
.audit-quotation
  .el-row
    .el-col:nth-child(1)
      font-weight 500
</style>
